import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import StripeCoonection from "./components/StripeCoonection";
import ReviewSettings from "./components/ReviewSettings";
import SoftTypography from "components/SoftTypography";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import { useEffect, useState } from "react";
import Branding from "./components/Branding";
import Business from "./components/Business";
import Consumer from "./components/Consumer";
import CustomTabs from "../../components/CustomTabs";
import ProfileSettings from "./components/ProfileSettings";
import CustomCode from "./components/CustomCode";
import { Snackbar } from "@mui/material";
import Workflows from "./components/Workflows";

function Settings() {
  const AppService = useAppServices();
  const [agency, , , , , , Update] = useAgencyInfo();
  const [processing, setProcessing] = useState(false);
  const [customFields, setcustomFields] = useState([]);
  const [customValues, setcustomValues] = useState([]);
  const [workflows, setworkflows] = useState([]);
  const [selectedTheme, setSelectedTheme] = useState([]);
  const [open, setOpen] = useState(false);
  const GetCustomFields = async () => {
    const { response } = await AppService.agency.getworkflows({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      setProcessing(false);
      if (response.data) {
        const temp_custom_fields = response.data.map((item, index) => ({
          ...item,
          label: item?.name,
          value: `${item?.id}-${item.fieldKey}`,
        }));
        setcustomFields(temp_custom_fields);
      }

      if (response?.workflows) {
        const temp_work_flows = response.workflows?.map((item, index) => ({
          ...item,
          label: item?.name,
          value: `${item?.id}`,
        }));
        setworkflows(temp_work_flows);
      }
      if (response?.custom_values) {
        const temp_custom_values = response.custom_values?.map((item, index) => ({
          ...item,
          label: item?.name,
          value: `${item?.id}-${item?.name}`,
        }));
        setcustomValues(temp_custom_values);
      }
    } else {
      setProcessing(false);
    }
  };

  const getActiveTheme = async (queryTheme) => {
    const { response } = await AppService.themes.get({ query: `_id=${agency?.theme_id}` });
    console.log('responseresponse', response?.data)
    if (response) {
      setSelectedTheme(response.data[0]);
    }
  };

  const onLoad = async () => {
    GetCustomFields();
    getActiveTheme();
  };
  useEffect(() => {
    onLoad();
  }, []);

  const handelThemeData = async (data) => {
    console.log('datadatadata', data)
    try {
      const submitData = {
        ...selectedTheme,
      };

      if (submitData.theme_data && submitData.theme_data.domain) {
        console.log(submitData.theme_data.domain, "submitData.theme_data.domain");
        submitData.theme_data.domain.domain_update = false;
      }

      const updatedThemeData = {
        ...submitData.theme_data,
        general: data.general, // Only update the general part in theme_data
      };

      const payload = {
        agency_id: agency?._id,
        theme_data: updatedThemeData,
        theme_type: "agency",
        theme_id: selectedTheme.theme_id,
        profile: data?.profile
      };

      const { response } = await AppService.themes.updateOrCreateByAgencyId({ payload });
      if (response) {
        setSelectedTheme((prev) => ({
          ...prev,
          theme_data: updatedThemeData,
        }));
        setOpen(true);
      }
    } catch (error) {
      console.error("Error updating theme data: ", error);
    }
  };

  const handleAutoConfigure = async () => {
    const { response } = await AppService.webhook.auto_configure_data_mapping({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      Update(response.data);
    }
  };
  const tabsData = [
    { label: "Profile Settings", content: <ProfileSettings selectedTheme={selectedTheme} handelThemeData={handelThemeData} /> },
    { label: "Integrations", content: <StripeCoonection data={agency} /> },
    // {
    //   label: "Business Mapping",
    //   content: <Business data={agency} customFields={customFields} workflows={workflows} />,
    // },
    // {
    //   label: "Consumer Mapping",
    //   content: <Consumer data={agency} customFields={customFields} workflows={workflows} />,
    // },
    // {
    //   label: "Branding Mapping",
    //   content: <Branding data={agency} customValues={customValues} />,
    // },
    {
      label: "Workflow Mapping",
      content: <Workflows data={agency} workflows={workflows} />,
    },
    {
      label: "Review Settings",
      content: <ReviewSettings />,
    },
    {
      label: "Custom Code",
      content: <CustomCode />,
    },
  ];
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  return (
    <PageLayout>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message="Theme Updated Successfully"
        action={[]}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <SoftBox className="d-flex " style={{ justifyContent: "space-between" }}>
            <SoftTypography
              variant={"h2"}
              textTransform="capitalize"
              fontWeight="600"
            >
              Settings
            </SoftTypography>
            {!agency?.auto_configure && (
              <button
                onClick={handleAutoConfigure}
                className="btn-new-design-black-addacount font-16"
                style={{
                  margin: "0px 0px 0px 10px",
                  padding: "10px 20px",
                  border: "green",
                  color: "green",
                }}
                type="submit"
                variant="outlined"
                color={"dark"}
                size="small"
              >
                Auto Configure
              </button>
            )}
          </SoftBox>
        </Grid>
        <Grid item xs={12}>
          <SoftBox display="flex-col" justifyContent="space-between" alignItems="center">
            <CustomTabs tabsData={tabsData} />
          </SoftBox>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

export default Settings;
